document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})}}));});

// Header/mobile menu
document.addEventListener('DOMContentLoaded',()=>{
  const btn=document.querySelector('.mobile-menu');
  const nav=document.querySelector('#mobile-nav');
  if(!btn||!nav) return;
  btn.addEventListener('click',()=>{
    const open=btn.getAttribute('aria-expanded')==='true';
    btn.setAttribute('aria-expanded',String(!open));
    nav.hidden=open;
  });
  nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
    btn.setAttribute('aria-expanded','false'); nav.hidden=true;
  }));
});
